import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import { fetchStreets, type StreetsFilters } from '../services/streets.service'

export { type StreetsFilters } from '../services/streets.service'

export function injectStreetsQuery(filters: Signal<StreetsFilters>) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['streets', filters()],
    queryFn: async ({ signal }) => {
      return fetchStreets(cartoClient, filters(), signal)
    },
    enabled: filters().delivery_id > 0,
  }))
}
